import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  SR_API_ACTION_GET_LISTING_BY_FUZZY_ADDRESS_SEARCH,
} from 'api/actionTypes';

import {
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';

import withApiState from 'client/helpers/withApiState';

import postWithState from 'client/actions/postWithState';
import ButtonDeprecated, { BUTTON_THEME_YELLOW } from 'client/components/ButtonDeprecated';
import SrDarkModal from 'client/components/SrDarkModal';
import SrTable from 'client/components/SrTable';
import SrFormikField from 'client/components/SrFormikField';
import SrModalContent from 'client/components/SrModalContent';
import SrLink from 'client/components/SrLink/SrLink';

import log from 'client/lib/log';

const formFields = [
  {
    id: 'addressStreetDisplay',
    type: 'short_text',
    validations: ['required'],
  },
];

@withApiState({
  fuzzyListingAddressSearchApiState: {
    action: SR_API_ACTION_GET_LISTING_BY_FUZZY_ADDRESS_SEARCH,
  },
})
class SrFindListingByAddressModal extends Component {
  static propTypes = {
    initialValue: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    fuzzyListingAddressSearchApiState: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      listingsMatch: [],
    };
    this._isUnmounting = false;
  }

  componentDidMount() {
    const { initialValue } = this.props;
    if (initialValue) {
      this._onFindListingByListingAddress({ addressStreetDisplay: initialValue });
    }
  }

  componentWillUnmount() {
    this._isUnmounting = true;
  }

  _onFindListingByListingAddress = ({ addressStreetDisplay }) => {
    const { dispatch } = this.props;
    dispatch(postWithState, {
      action: SR_API_ACTION_GET_LISTING_BY_FUZZY_ADDRESS_SEARCH,
      payload: {
        addressStreetDisplay,
      },
    })
      .then((listings) => {
        if (!this._inUnmounting) {
          this.setState({
            listingsMatch: listings,
          });
        }
      })
      .catch((error) => {
        log.error(error);
      });
  }

  render() {
    const {
      initialValue,
      onClose,
      onSubmit,
      fuzzyListingAddressSearchApiState,
    } = this.props;

    const {
      listingsMatch,
    } = this.state;

    return (
      <SrDarkModal>
        <SrModalContent>
          <div className='closeIcon' onClick={onClose} />
          <Formik
            initialValues={createInitialValues({
              formFields: formFields,
              defaultValues: {
                addressStreetDisplay: initialValue || '',
              },
            })}
            validate={createFormValidationFn(formFields)}
            onSubmit={this._onFindListingByListingAddress}
            render={(formikBag) => (
              <Form>
                {formFields.map((formField) => (
                  <SrFormikField
                    key={formField.id}
                    formField={formField}
                    formikBag={formikBag}
                  />
                ))}
                <ButtonDeprecated
                  theme={BUTTON_THEME_YELLOW}
                  type='submit'
                  disabled={!formikBag.isValid}
                >
                  {fuzzyListingAddressSearchApiState.inProgress
                    ? 'loading...'
                    : 'search'
                  }
                </ButtonDeprecated>
              </Form>
            )}
          />
          {!fuzzyListingAddressSearchApiState.inProgress && (
            listingsMatch.length > 0
              ? (
                <SrTable
                  headers={[
                    { content: 'Address' },
                    { content: '' },
                  ]}
                  rows={listingsMatch.map((listing) => ({
                    cells: [
                      {
                        content: (
                          <SrLink target='_blank' to={`/listing/${listing.id}`}>
                            {listing.addressStreetDisplay}
                          </SrLink>
                        ),
                      },
                      {
                        content: (
                          <span className='blue-link' onClick={() => onSubmit(listing)}>
                            choose listing
                          </span>
                        ),
                      },
                    ],
                  }))}
                />
              )
              : (
                <span>No results.</span>
              )
          )}
        </SrModalContent>
      </SrDarkModal>
    );
  }
}

SrFindListingByAddressModal.displayName = 'SrFindListingByAddressModal';

export default SrFindListingByAddressModal;
